export default "__VITE_ASSET__iQ1Ri9zo__"